import React, { useEffect, useState } from "react";
import "./toggle-switch.css";
import * as elementUtils from "../../utils/elementUtils";
import { ConfirmationModal } from "../Modals/ConfirmationModal/confirmation-modal";
import { wait } from "../../utils/genericUtils";

const toggleDefaults = {
  id: "toggle-switch",
  active: false,
  initialLoad: false,
  activeImage: null,
  inactiveImage: null,
  useConfirmation: false,
  //sample settings for include confirmation modal
  confirmationSettings: {
    id: "id",
    isActive: false,
    header: "header",
    message: "message",
    headerFontSize: 25,
    messageFontSize: 15,
    icon: undefined,
    iconLeft: false,
    textAlign: "left",
    showDivider: true,
    animate: true,
    animationTime: 500,
    bg_opacity: 0.5,
    height: undefined,
    width: undefined,
    includeCheckboxSafety: true,
    safetyText: "Warning...",
    includeDontAskAgain: false,
    dontAskSetting: "",
    confirmText: "Yes",
    confirmClass: "",
    denyText: "Nevermind",
    denyClass: "",
    onDeny: () => {},
    onConfirm: () => {},
    onClickOut: () => {},
  },
  onActive: () => {},
  onInActive: () => {},
};

function ToggleSwitch(props = toggleDefaults) {
  const [active, setActive] = useState(props.active);
  const [confirmationModalActive, setConfirmationModalActive] = useState(false);
  const animationTime = 300;

  useEffect(() => {
    // if (props.initialLoad) {
    // }
    DefaultTogglePosition(props.active);
    if (!props.useConfirmation) setConfirmationModalActive(false);
  }, [props.active]);

  function OnToggle() {
    if (props.useConfirmation === true) {
      setConfirmationModalActive(true);
    } else {
      ToggleLogic();
    }
  }

  function ToggleLogic() {
    let slider = document.querySelector("#" + props.id + "-slider");
    if (active) {
      //currently active setting to inactive
      let parent_rect = slider.parentElement.parentElement.getBoundingClientRect();
      let slider_rect = slider.getBoundingClientRect();
      let posX = 100 - (slider_rect.width / parent_rect.width) * 100 + "%";
      elementUtils.moveElement(slider, animationTime, { left: posX }, { left: "0%" });
      setActive(false);
      if (props.onInActive) props.onInActive();
      //update slider color
    } else {
      //currently inactive setting to inactive
      let parent_rect = slider.parentElement.parentElement.getBoundingClientRect();
      let slider_rect = slider.getBoundingClientRect();
      let posX = 100 - (slider_rect.width / parent_rect.width) * 100 + "%";
      elementUtils.moveElement(slider, animationTime, { left: "0%" }, { left: posX });
      setActive(true);
      if (props.onActive) props.onActive();
    }
  }

  function DefaultTogglePosition(active) {
    setActive(active);
    let slider = document.querySelector("#" + props.id + "-slider");
    if (!active) {
      //currently active setting to inactive
      let parent_rect = slider.parentElement.parentElement.getBoundingClientRect();
      let slider_rect = slider.getBoundingClientRect();
      let posX = 100 - (slider_rect.width / parent_rect.width) * 100 + "%";
      elementUtils.moveElement(slider, animationTime, { left: posX }, { left: "0%" });
    } else {
      //currently inactive setting to inactive
      let parent_rect = slider.parentElement.parentElement.getBoundingClientRect();
      let slider_rect = slider.getBoundingClientRect();
      let posX = 100 - (slider_rect.width / parent_rect.width) * 100 + "%";
      elementUtils.moveElement(slider, animationTime, { left: "0%" }, { left: posX });
    }
  }

  const baseClass = "toggle-switch-outer ";
  return (
    <>
      {props.useConfirmation === true && (
        <ConfirmationModal
          {...props.confirmationSettings}
          isActive={confirmationModalActive}
          onConfirm={() => {
            let func = props.confirmationSettings.onConfirm;
            if (func) func();
            ToggleLogic();
          }}
          onDeny={() => setConfirmationModalActive(false)}
          onClickOut={() => setConfirmationModalActive(false)}
        ></ConfirmationModal>
      )}
      <div data-active={props.active} onClick={OnToggle} id={props.id} className={active || props.active ? baseClass + "toggle-active" : baseClass}>
        <div id={props.id + "-slider"} className="toggle-switch-inner">
          {props.activeImage && props.inactiveImage ? (
            <img className={"toggle-switch-image"} src={active || props.active ? props.activeImage : props.inactiveImage} alt="toggle image" />
          ) : null}
        </div>
      </div>
    </>
  );
}

export default ToggleSwitch;
